// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxInput_wrapper__fOTuk","circle":"CheckboxInput_circle__coEme"};